// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapPOIS_wrapper__3MkQf","map_title_style":"MapPOIS_map_title_style__3w1Xi"};